import { createApp } from 'petite-vue'

const materialCalculator = createApp( {
  /**
   * The length in feet.
   */
  length: 10,
  /**
   * The width in feet.
   */
  width: 10,
  /**
   * The depth in inches.
   */
  depth: 2,
  /**
   * The radius in feet.
   */
  radius: 10,
  /**
   * The inside radius in feet.
   */
  radiusInside: 10,
  /**
   * The outside radius in feet.
   */
  radiusOutside: 20,
  /**
   * The size of the space in square feet.
   */
  space: 100, // default value
  labelClass: 'uppercase tracking-wider block mbe-2 font-bold',
  inputClass: 'rounded-md bg-gray-light p-3 w-32 text-primary font-bold',
  options: [ 'rectangular', 'circle', 'square-footage' ],
  current: 'rectangular',
  /**
   * The density of the material in tons per cubic foot.
   * Default: 0.0498 (average for materials like stone or gravel)
   */
  density: 0.0498,
  /**
   * The volume of one cubic yard in cubic feet.
   * 1 cubic yard = 27 cubic feet
   */
  cubicYard: 27,
  /**
   * Arbitrary constant that is used to estimate the weight of the material.
   */
  arbitraryConstant: 1.5,
  /**
   * Calculate estimated cubic yards for a rectangular area.
   * Formula: (length x width x depth in feet) / cubic yard volume
   */
  get estimatedCubicYardsRectangle() {
    return ( this.length * this.width * ( this.depth / 12 ) / this.cubicYard ).toFixed( 2 )
  },
  /**
   * Calculate estimated tons for a rectangular area.
   * Formula: cubic yards x arbitrary constant (weight per cubic yard)
   */
  get estimatedTonsRectangle() {
    return ( this.estimatedCubicYardsRectangle * this.arbitraryConstant ).toFixed( 2 )
  },
  /**
   * Calculate estimated cubic yards for a circular area.
   * Formula: π x radius² x depth in feet / cubic yard volume
   */
  get estimatedCubicYardsCircle() {
    return ( Math.PI * Math.pow( this.radius, 2 ) * ( this.depth / 12 ) / this.cubicYard ).toFixed( 2 )
  },
  /**
   * Calculate estimated tons for a circular area.
   * Formula: cubic yards x arbitrary constant (weight per cubic yard)
   */
  get estimatedTonsCircle() {
    return ( this.estimatedCubicYardsCircle * this.arbitraryConstant ).toFixed( 2 )
  },
  /**
   * Calculate estimated cubic yards for a square footage area.
   * Formula: (space in square feet x depth in feet) / cubic yard volume
   */
  get estimatedCubicYardsSquareFootage() {
    return ( ( this.space * ( this.depth / 12 ) ) / this.cubicYard ).toFixed( 2 )
  },
  /**
   * Calculate estimated tons for a square footage area.
   * Formula: cubic yards x arbitrary constant (weight per cubic yard)
   */
  get estimatedTonsSquareFootage() {
    return ( this.estimatedCubicYardsSquareFootage * this.arbitraryConstant ).toFixed( 2 )
  },
} )

export default materialCalculator